export default __webpack_public_path__ + "static/media/logo-green.68accfec.png";